import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Avatar,
  Divider,
  IconButton,
} from "@mui/material";
import { EventSeat, History, Settings, Email, Phone, CalendarMonth } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const quickActions = [
    // {
    //   title: "Book a Table",
    //   description: "Reserve a table for your next dining experience",
    //   icon: <EventSeat sx={{ fontSize: 36 }} />,
    //   action: () => navigate("/book-table"),
    //   color: "primary.main",
    // },
    // {
    //   title: "My Bookings",
    //   description: "View and manage your reservations",
    //   icon: <History sx={{ fontSize: 36 }} />,
    //   action: () => navigate("/my-bookings"),
    //   color: "secondary.main",
    // },
    // {
    //   title: "Profile Settings",
    //   description: "Update your personal information",
    //   icon: <Settings sx={{ fontSize: 36 }} />,
    //   action: () => navigate("/profile"),
    //   color: "success.main",
    // },
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Welcome back, {user?.name}!
      </Typography>

      <Grid container spacing={4}>
        {/* Profile Section */}
        <Grid item xs={12} md={4}>
          <Card
            elevation={4}
            sx={{
              borderRadius: 4,
              p: 3,
              textAlign: "center",
              background: "linear-gradient(135deg, #f9f9f9, #fff)",
            }}
          >
            <Avatar
              sx={{
                width: 90,
                height: 90,
                mx: "auto",
                bgcolor: "primary.main",
                fontSize: "2.2rem",
                mb: 2,
              }}
            >
              {user?.name?.charAt(0)?.toUpperCase()}
            </Avatar>
            <Typography variant="h6">{user?.name}</Typography>
            <Box mt={1}>
              <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
                <Email fontSize="small" sx={{ mr: 1, color: "text.secondary" }} />
                <Typography variant="body2" color="text.secondary">
                  {user?.email}
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
                <Phone fontSize="small" sx={{ mr: 1, color: "text.secondary" }} />
                <Typography variant="body2" color="text.secondary">
                  {user?.phone}
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" justifyContent="center">
                <CalendarMonth fontSize="small" sx={{ mr: 1, color: "text.secondary" }} />
                <Typography variant="body2" color="text.secondary">
                  Member since:{" "}
                  {new Date(user?.createdAt || Date.now()).toLocaleDateString()}
                </Typography>
              </Box>
            </Box>
          </Card>
        </Grid>

        {/* Quick Actions */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={3}>
            {quickActions.map((action, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Card
                  elevation={3}
                  sx={{
                    borderRadius: 3,
                    transition: "0.3s",
                    "&:hover": { boxShadow: 6, transform: "translateY(-4px)" },
                  }}
                >
                  <CardActionArea onClick={action.action}>
                    <CardContent>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                          bgcolor: action.color,
                          width: 60,
                          height: 60,
                          borderRadius: "50%",
                          mb: 2,
                          mx: "auto",
                          color: "#fff",
                        }}
                      >
                        {action.icon}
                      </Box>
                      <Typography variant="h6" align="center" gutterBottom>
                        {action.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        align="center"
                      >
                        {action.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Dashboard;
